import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Table',
  name: 'tableBlock',
  type: 'object',
  fields: [
    defineField({
      name: 'title',
      title: 'Title',
      type: 'string',
    }),
    defineField({
      name: 'table',
      title: 'Table',
      type: 'table',
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title }) {
      return {
        title: title || 'Untitled',
        subtitle: 'Table',
      }
    },
  },
})